module.exports = __webpack_public_path__ + "Lato-Bold.77b35eb865c0633857f6.eot";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Bold.eot
// module id = ../../../../../src/assets/fonts/Lato-Bold.eot
// module chunks = styles